<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn-primary" (click)="doSqlFormatter()">
        <mat-icon fontIcon="report"></mat-icon>立刻執行
      </button>
      <button class="btn-secondary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="jk-grid-cols-3">
      <div>
      <app-jktextarea label="sql format:" [rows]="20" name="sqlFormat" class="w-full" [required]="true"
      [(value)]="filterOpt.input"  [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400"
       >
      </app-jktextarea>
      <mat-divider></mat-divider>
      <app-jktextarea label="format結果:" [rows]="20" name="sqlFormatOK" class="w-full" [required]="true"
      [(value)]="filterOpt.output"  [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400"
       >
      </app-jktextarea>

    </div>
    </div>
  </mat-tab>
  <mat-tab #myTabResult label="執行結果" >
    <div>
      <app-jktextarea label="PS" [rows]="3" name="comment" id="comment" class="w-full" [required]="true"
        [(value)]="logMessage"  [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400"
         >
      </app-jktextarea>
    </div>
</mat-tab>
</mat-tab-group>

